export default [
  {
    path: '/dashboard/:key?',
    name: 'dashboard',
    component: () => import('@/views/dashboard/DashboardIndex.vue'),
    meta: {},
  },
];
